/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

	jQuery(window).on("load",function(){
		jQuery("#preloader").fadeOut(2000);
	});

	jQuery("#ae-cform-reg-item-email-1 input").attr("placeholder", "Email Address (Required)");
	
	jQuery(".nav-newsletter").click(function(){
		jQuery(".form-toggle").slideDown("fast");
		jQuery(".js-off-canvas-overlay").trigger( "click" );
	});

	jQuery(".cookie a").on("click", function (event) {
		jQuery("#_evh-link").trigger("click");
	});

	jQuery(".close-toggle").click(function(){
		jQuery(".form-toggle").slideUp("fast");
	});

	var $win = jQuery(window),
	$body = jQuery('body'),
	$main = jQuery('.main');
	

	//console.log('hola');

	if( $body.hasClass('home') ) {
		jQuery(".subscribe a").click(function (){
			var $container = jQuery("html,body");
			var $scrollTo = jQuery('.section-subscribe');

			$container.animate({scrollTop: $scrollTo.offset().top - $container.offset().top + $container.scrollTop(), scrollLeft: 0},1000);
		});
		setTimeout(
			function() 
			{
			  //do something special
		  jQuery('#modalform').foundation('open');
		}, 10000);
	}else{
		jQuery('.subscribe a').attr("data-open", "modalform");
	}

	jQuery('.top-bar .menu-bars').on('click', function() {
		jQuery(this).find('.fas').toggleClass('fa-times');
	});
	jQuery('.js-off-canvas-overlay').on('click', function() {
		jQuery('.top-bar .menu-bars .fas').removeClass('fa-times');
	});
	
	if( $body.hasClass('home') ) {
		jQuery( "body" ).addClass( "top-header" );
		/*
		//THEY ASK TO ADD THE PHOTO PAGE AS A HOMEPAGE, IN HERE YOU CAN CHANGE ANY AJAX PAGE CONTENT TO CHECK THE HOMEPAGE
		function getpagehome_load_posts(){
			var str_getpagephotos = '&action=page_home_ajax';
			jQuery.ajax({
				type: "POST",
				dataType: "html",
				url: ajax_posts.ajaxurl,
				data: str_getpagephotos,
				success: function(data){
					//console.log('funciona');
					var $data_getpagephotos = jQuery(data);
					if(jQuery("#photos").length == 0){

						if(jQuery("#content").hasClass("active-getclose")){
							jQuery("#content").removeClass("active-getclose");
							jQuery("#content").addClass("active-photos");
                            setTimeout(function() {
								//jQuery("#content.active-getclose").animate({height: '0'}, 1000);
								jQuery("#content span.transition").animate({height: '0'}, 500);
								jQuery("#content span.transition").animate({opacity: 1}, 1000);
								jQuery(".section-feat-video").animate({opacity: 0}, 500);
								//jQuery(".section-feat-video .overlay, .section-feat-video img").animate({height: '0'}, 1000);
							}, 500);

                            setTimeout(function() {
								jQuery( "#content section" ).not(this).remove();
								jQuery('#content').append($data_getpagephotos);

								jQuery("#content.active-photos").animate({height: '100%'}, 500);
								jQuery("#content span.transition").animate({height: '100%'}, 800);
								jQuery("#content span.transition").animate({opacity: 0}, 1000);

                                jQuery(".section-photos").delay(200).animate({opacity: 1}, 1000);
							}, 2500);
							
						}else if(jQuery("#content").hasClass("active-videos")){

                            jQuery("#content").removeClass("active-videos");
							jQuery("#content").addClass("active-photos");
							setTimeout(function() {
								//jQuery("#content.active-videos").animate({height: '0'}, 1000);
								jQuery("#content span.transition").animate({height: '0'}, 1000);
								jQuery("#content span.transition").animate({opacity: 1}, 500);
								jQuery("#videos").animate({opacity: 0}, 500);
							}, 500);

                            setTimeout(function() {
								jQuery( "#content section" ).not(this).remove();
								jQuery('#content').append($data_getpagephotos);

								jQuery("#content.active-photos").animate({height: '100%'}, 500);
								jQuery("#content span.transition").animate({height: '100%'}, 800);
								jQuery("#content span.transition").animate({opacity: 0}, 1000);

                                jQuery(".section-photos").delay(200).animate({opacity: 1}, 1000);
							}, 2500);

						}else if(jQuery("#content").hasClass("active-music")){
                            jQuery("#content").removeClass("active-music");
                            jQuery("#content").addClass("active-photos");

                            setTimeout(function() {
								jQuery("#content").animate({height: '0'}, 1000);
								jQuery("#content span.transition").animate({height: '0'}, 1000);
								jQuery("#content span.transition").animate({opacity: 1}, 500);
								jQuery("#music").animate({opacity: 0}, 500);
							}, 500);

                            setTimeout(function() {
								jQuery( "#content section" ).not(this).remove();
								jQuery('#content').append($data_getpagephotos);

								jQuery( "body" ).removeClass( "middle-header" );
								jQuery( "body" ).addClass( "top-header" );

								jQuery("#content.active-photos").animate({height: '100%'}, 500);
								jQuery("#content span.transition").animate({height: '100%'}, 800);
								jQuery("#content span.transition").animate({opacity: 0}, 1000);

                                jQuery(".section-photos").delay(200).animate({opacity: 1}, 1000);
							}, 2500);

						}else if(jQuery("#content").hasClass("active-tour")){
                            jQuery("#content").removeClass("active-tour");
                            jQuery("#content").addClass("active-photos");

                            setTimeout(function() {
								jQuery("#content").animate({height: '0'}, 1000);
								jQuery("#content span.transition").animate({height: '0'}, 1000);
								jQuery("#content span.transition").animate({opacity: 1}, 500);
								jQuery("#tour").animate({opacity: 0}, 500);
							}, 500);

                            setTimeout(function() {
								jQuery( "#content section" ).not(this).remove();
								jQuery('#content').append($data_getpagephotos);

								jQuery( "body" ).removeClass( "middle-header" );
								jQuery( "body" ).addClass( "top-header" );

								jQuery("#content.active-photos").animate({height: '100%'}, 500);
								jQuery("#content span.transition").animate({height: '100%'}, 800);
								jQuery("#content span.transition").animate({opacity: 0}, 1000);

                                jQuery(".section-photos").delay(200).animate({opacity: 1}, 1000);
							}, 2500);

						}else{
							jQuery("#content").addClass("active-photos");
							setTimeout(function() {

								jQuery( "#content section" ).not(this).remove();
								jQuery('#content').append($data_getpagephotos);

								jQuery( "body" ).removeClass( "middle-header" );
								jQuery( "body" ).addClass( "top-header" );

								jQuery("#content.active-photos").animate({height: '100%'}, 500);
								jQuery("#content span.transition").animate({height: '100%'}, 800);
								jQuery("#content span.transition").animate({opacity: 0}, 1000);

                                jQuery(".section-photos").animate({opacity: 1}, 1000);

							}, 0);
						}
					}
				},
				error : function(jqXHR, textStatus, errorThrown) {
					//console.log('error');
					jQuery('.message-error').html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
				}

			});
			return false;
		}

		
		getpagehome_load_posts();*/
		
		//console.log('hola estoy ejecutando')
	} 

	jQuery('.music-list').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		speed: 300,
		centerMode: false,
		cssEase: "ease-in-out",
		useTransform: true,
		dots: false,
		fade: false,
		responsive: [
						{
							breakpoint: 1200,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 1
							}
						},
						{
							breakpoint: 600,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1
							}
						}
					]
	});

/*
	if( $body.hasClass('single-video') || $body.hasClass('page-id-8') || $body.hasClass('page') ) {
		var ppp = 4; // Post per page
		var pageNumber = 1;

		function load_posts(){
			pageNumber++;
			var str = '&pageNumber=' + pageNumber + '&ppp=' + ppp + '&action=more_videos_ajax';
			jQuery.ajax({
				type: "POST",
				dataType: "html",
				url: ajax_posts.ajaxurl,
				data: str,
				success: function(data){
					//console.log('funciona');
					var $data = jQuery(data);
					if($data.length){
						jQuery("#videos-list").append($data);
						jQuery("#more_videos").attr("disabled",false);
					} else{
						jQuery("#more_videos").attr("disabled",true);
						jQuery("#more_videos").addClass("disabled");
					}
				},
				error : function(jqXHR, textStatus, errorThrown) {
					//console.log('error');
					jQuery('.latest .section-footer').html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
				}

			});
			return false;
		}

		jQuery("#more_videos").on("click",function(e){ // When btn is pressed.
			e.preventDefault();

			jQuery("#more_videos").attr("disabled",true); // Disable the button, temp.
			load_posts();
		});
	} // single-video and video page*/

	jQuery(".button-video").mouseenter(function(){
		var prev_video = jQuery(this).data( "video" );
		var content_video = jQuery(this).data( "content" );
		console.log("entra");
		jQuery('#'+prev_video).animate({
			opacity: "1"
		});
		jQuery('.video-info').not('#'+content_video).animate({
			opacity: "0"
		})
		jQuery('#'+prev_video).get(0).play();
	}).mouseleave(function(){
		var prev_video = jQuery(this).data( "video" );
		var content_video = jQuery(this).data( "content" );
		console.log("sale");
		jQuery('#'+prev_video).animate({
			opacity: "0"
		});
		jQuery('.video-info').not('#'+content_video).animate({
			opacity: "1"
		})
		jQuery('#'+prev_video).get(0).pause();
    	jQuery('#'+prev_video).currentTime = 0;
	});

});    


